import { ITkInquiryTableListProps } from "./components/components";

const inquiryList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "契約者番号",
      keyword: "contractorNo",
      text: "130001",
    },
    {
      title: "契約者種別",
      keyword: "businessOwnerClass",
    },
  ],
  [
    {
      title: "契約者名（ｶﾅ）",
      keyword: "corpNameKana",
    },
  ],
  [
    {
      title: "契約者名",
      keyword: "corpName",
    },
  ],
  [
    {
      title: "契約者住所",
      keyword: "address",
    },
  ],
  [
    {
      title: "法人番号",
      keyword: "corpNumber",
    },
    {
      title: "TEL",
      keyword: "tel",
    },
  ],
  [
    {
      title: "法人メールアドレス",
      keyword: "contactEmail",
    },
    {
      title: "FAX",
      keyword: "fax",
    },
  ],
  [
    {
      title: "代表者職名",
      keyword: "directorTitle",
    },
    {
      title: "代表者名",
      keyword: "directorName",
    },
  ],
  [
    {
      title: "所属部署",
      keyword: "deptName",
    },
    {
      title: "担当者名",
      keyword: "name",
    },
  ],
  [
    {
      title: "掛金届出有無",
      keyword: "inputPaymentNotification",
    },
    {
      title: "システム利用有無",
      keyword: "corpApplyKbn",
    },
  ],
  [
    {
      title: "決裁日",
      keyword: "contractApprovalDate",
    },
    {
      title: "契約日",
      keyword: "contractDate",
    },
  ],
  [
    {
      title: "契約区分",
      keyword: "contractKbn",
    },
    {
      title: "前契約者番号",
      keyword: "bContractorNo",
    },
  ],
];

const returnStatusList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "振込先金融機関コード",
      keyword: "billingBankCd",
    },
    {
      title: "振込先金融機関名",
      keyword: "billingBankName",
    },
  ],
  [
    {
      title: "支店コード",
      keyword: "billingBranchCd",
    },
    {
      title: "支店名",
      keyword: "billingBranchName",
    },
  ],
  [
    {
      title: "預金種類",
      keyword: "deposit_type",
    },
    {
      title: "口座番号",
      keyword: "billingAccountNo",
    },
  ],
  [
    {
      title: "口座名義（ﾌﾘｶﾞﾅ）",
      keyword: "billingAccountHolderKana",
    },
  ],
  [
    {
      title: "返還日",
      keyword: "withdrawalDate",
    },
    {
      title: "返還金額",
      keyword: "transferAmt",
    },
  ],
];

const cancelInfoList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "解除日",
      keyword: "cancelDate",
    },
    {
      title: "解除決裁日",
      keyword: "cancelApprovalDate",
    },
  ],
  [
    {
      title: "解除理由",
      keyword: "cancelReason",
    },
  ],
];

const commentHeader: any = [
  { headTitle: "当該共済契約者に関するコメント", align: "left" },
];

const staffList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "4/1職員数",
      keyword: "staffNum",
    },
  ],
  [
    {
      title: "現在職員数",
      keyword: "staffNumNow",
    },
  ],
];

const salaryList: ITkInquiryTableListProps[][] = [
  [
    {
      title: "承認済手当",
      keyword: "approvedAllowance",
    },
  ],
  [
    {
      title: "非該当手当",
      keyword: "nonApprovedAllowance",
    },
  ],
];

const historyHeader: any = [
  { headTitle: "更新日時", align: "left" },
  { headTitle: "修正項目", align: "left" },
  { headTitle: "修正前", align: "left" },
  { headTitle: "修正後", align: "left" },
];

export {
  inquiryList,
  commentHeader,
  returnStatusList,
  cancelInfoList,
  staffList,
  salaryList,
  historyHeader,
};
